import { createColumnHelper } from '@tanstack/react-table';

import { EnvironmentListItem } from '../types';

export const columnHelper = createColumnHelper<EnvironmentListItem>();
